import React from 'react';
import { withRouter } from "react-router-dom";
import CompaniesComponent from './Companies.component';

const CompaniesLanding = (props) => {
  return (
    <CompaniesComponent setRecentSearch={props.setRecentSearch} recentSearch={props.recentSearch} loggedUserInfo={props.loggedUserInfo} userId={props.userId} clientId={props.clientId}  />
  )
        
}
export default withRouter(CompaniesLanding);